import React, { useEffect, useState } from "react";
import {
  FaShieldAlt,
  FaRocket,
  FaMoneyCheckAlt,
  FaWhatsapp,
  FaMoon,
  FaSun,
} from "react-icons/fa";

export default function NicePayLanding() {
  const [theme, setTheme] = useState("day");

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") || "day";
    setTheme(savedTheme);
    document.body.className =
      savedTheme === "night" ? "theme-night" : "theme-day";
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === "day" ? "night" : "day";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
    document.body.className =
      newTheme === "night" ? "theme-night" : "theme-day";
  };

  return (
    <div>
      <div class="d-flex flex-column min-vh-100">
        <header class="d-flex justify-content-between align-items-center p-4 border-bottom">
          <div class="text-danger font-weight-bold">
            <img
              src="/assets/img/logo-panjang.png"
              width="200px"
              class="img-fluid"
              alt="Logo"
            />
          </div>
          <nav class="nav">
            <a class="nav-link" href="/">
              Home
            </a>
            <a class="btn btn-custom" href="/backoffice/login">
              Login
            </a>
            <a class="btn btn-custom mx-2" href="/backoffice/signup">
              Signup
            </a>
            <button
              onClick={toggleTheme}
              className="btn btn-custom"
              title={theme === "day" ? "Night Mode" : "Day Mode"}
            >
              {theme === "day" ? <FaMoon size={22} /> : <FaSun size={22} />}
            </button>
          </nav>
        </header>

        <main class="flex-grow-1 p-4">
          <div class="container">
            <div class="row">
              <div class="col-md-8">
                <h1 class="font-weight-bold">
                  Pembayaran Lebih Cepat, <br />
                  Bisnis Lebih Hebat!
                </h1>

                <ul>
                  <li>Bayar Mudah, Terima Cepat Bersama NicePay!</li>
                  <li>Keamanan Tinggi, Transaksi Nyaman!</li>
                  <li>Real-time Payment, Real-time Growth!</li>
                  <li>Satu Gateway, Semua Pembayaran!</li>
                </ul>
              </div>
              <div class="col-md-4 text-center">
                <img
                  src="/assets/img/logo-kotak.png"
                  class="img-fluid"
                  alt="Logo"
                />
              </div>
            </div>

            <div class="row mt-4">
              {/* Keunggulan NicePay */}
              <div id="features" className="row mt-5">
                <div className="col-md-4">
                  <div className="card shadow-sm p-4">
                    <FaShieldAlt className="text-primary display-4 mb-3" />
                    <h3 className="h5">Keamanan Tinggi</h3>
                    <p>3D Secure, AI Fraud Detection</p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card shadow-sm p-4">
                    <FaRocket className="text-primary display-4 mb-3" />
                    <h3 className="h5">Proses Cepat</h3>
                    <p>Transaksi real-time & pencairan instan</p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card shadow-sm p-4">
                    <FaMoneyCheckAlt className="text-primary display-4 mb-3" />
                    <h3 className="h5">Multi-Payment</h3>
                    <p>QRIS dan Virtual Account</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>

        <footer class="text-center p-4 border-top">
          Nice Pay Indonesia © 2025 All rights reserved
        </footer>
      </div>

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/6289653599531?text=Halo%20NicePay,%20saya%20ingin%20bertanya"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <FaWhatsapp size={30} />
      </a>
    </div>
  );
}
